import React from 'react';
import CustomButton from './CustomButton';
import './theme.css';

export default class ImageArtwork extends React.Component {
  constructor(props) {
    super(props);
    //props : ImgUrl, SiteUrl1, SiteUrl2, OnLoaded, SeqId
    this.SeqId = props.SeqId;
    this.clickHandler = this.clickHandler.bind(this);
    this.loadHandler = this.loadHandler.bind(this);
    this.state = {
      clicked: false,
      loaded: false
    };

  }

  clickHandler(e) {
    this.setState({
      clicked: !this.state.clicked
    });
  }

  loadHandler(e) {
    this.setState({loaded: true});
    this.props.OnLoaded();
  }

  render() {
    return (<div id={'img'+this.SeqId} style={{
        position: 'relative'
      }}>
      <img src={this.props.ImgUrl} className="kepek blurrable" onLoad={this.loadHandler} onClick={this.clickHandler} style={{
          opacity: Number(this.state.loaded),
          filter: (this.state.clicked?'blur(10px) brightness(50%)':'none')
        }} alt=""/>
      <div style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translateX(-50%)',
          textAlign: 'center',
          width: '100%',
          visibility: (
            this.state.clicked
            ? 'visible'
            : 'hidden'),
          opacity: Number(this.state.clicked),
          transition: "visibility 1s, opacity 1s, filter 2s"
        }}>
        <div style={{display: 'inline-block', padding: '3%'}} >
          <CustomButton big newTab url={this.props.SiteUrl1} tooltip='View on DeviantArt' icon='comment'/>
        </div>
        <div style={{display: 'inline-block', padding: '3%'}} >
          <CustomButton big newTab url={this.props.SiteUrl2} tooltip='View on ArtStation' icon='comment'/>
        </div>
        <div style={{display: 'inline-block', padding: '3%'}} >
          <CustomButton big download url={this.props.ImgUrl} tooltip='Download wallpaper' icon='file_download'/>
        </div>
    </div>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/Component/ImageArtwork.js